import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { AssetTypeSettingsGeneralViewTopBar } from "./TopBar"

export const assetTypeGeneralViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: AssetTypeSettingsGeneralViewTopBar,
}
